import React from 'react';
import BasicTable from './demo';

class Reports extends React.PureComponent {
  constructor (props) {
    super(props);
    this.state = {
      reload: (((this.props || {}).location || {}).navProps || {}).reload
    };
  }

  componentDidMount() { }
  static getDerivedStateFromProps (newProps, state) {
    if ((((newProps || {}).location || {}).navProps || {}).reload !== (state || {}).reload) {
      // this.LoadData();
      return {
        reload: ((newProps.location || {}).navProps || {}).reload
      };
    }
    return null;
  }

  render () {
    return (<div>
      <BasicTable reload={this.state.reload}></BasicTable>
  </div>);
  }
}
// function Reports(props) {
//   const [reload, steReload] = React.useState(false);

//   useEffect(() => {
//     steReload(!steReload);
//   }, [((props.location || {}).navProps || {}).reload]);

//   return <div>
//       <BasicTable reload={reload}></BasicTable>
//   </div>;
// }

export default Reports;
